<mat-nav-list>
  <h3 matSubheader>Hoe lang wil je meldingen dempen?</h3>
  @for (option of options; track option.label) {
    <mat-list-item (click)="select(option)">
      <mat-icon matListItemIcon>schedule</mat-icon>
      <span matListItemTitle>{{ option.label }}</span>
    </mat-list-item>
  }
</mat-nav-list>
